'use strict';
var userAgent = require('../internals/environment-user-agent');

module.exports = /ipad|iphone|ipod/i.test(userAgent) && /applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/internals/environment-is-ios.js
// module id = 242
// module chunks = 0